import { render, staticRenderFns } from "./AlipayPayConfig.vue?vue&type=template&id=7de500bd&scoped=true"
import script from "./AlipayPayConfig.vue?vue&type=script&lang=js"
export * from "./AlipayPayConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de500bd",
  null
  
)

export default component.exports